import React from 'react';

import { StyledVoucherWrapper } from '@sharedComponents/Benefits';
import { GridDivider } from '@sharedComponents/Separators';
import { ReactFCV } from '@types';
import { DIVIDER_COLOR, DIVIDER_HEIGHT } from '@utils/constants';
import { CypressTestNamespace } from '@utils/test';

import { VoucherAddButton } from './VoucherAddButton/VoucherAddButton';
import { VoucherList } from './VoucherList/VoucherList';

export const VoucherWrapper: ReactFCV = () => {
  return (
    <StyledVoucherWrapper className={CypressTestNamespace.ECartPageCoupons.COUPON_WRAPPER}>
      <GridDivider color={DIVIDER_COLOR} height={DIVIDER_HEIGHT} />
      <VoucherList />
      <VoucherAddButton />
    </StyledVoucherWrapper>
  );
};
